import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {Home,Event,AccountBalance,AccountBalanceWallet,Money,SwapHoriz,ArrowForwardIos,LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Edit,Delete,People,CheckCircleOutline,NotInterested,Cancel,RemoveCircleOutline,Visibility,VisibilityOff} from '@material-ui/icons';

import {weeklyTopup,AnnualTopUp} from "../../individual_agent/test_data";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Chip,
  isWidthUp,
  OutlinedInput,
  InputAdornment,
  Grid,
  Badge,
  Avatar,
  useMediaQuery
} from "@material-ui/core";

import { withLocalize,Translate } from "react-localize-redux";


import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';

// import * as userInfo from "./login_info.js";

import UserInfo from "../login_info";

import axios from 'axios';

import Format from "date-fns/format";


import {TransportService,AdminService,ReportingService,FinanceService,groupBy} from "../../../utils/web_config_2";
import { pink } from '@material-ui/core/colors';
import { set } from 'date-fns';

import {useHistory } from "react-router-dom";

import Chart from "react-apexcharts";


import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image
} from "@react-pdf/renderer";


import agentManagerImage from "../../../assets/svg/agent_manager.svg";




const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  btn: {
    textTransform: "capitalize",
  },
  paper: {
    padding: 15,
  },
  icon: {
    height: 45,
    marginRight: 10,
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  main: theme.mixins.toolbar
}));



function AgentHome() {
  const classes = useStyles();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [operatorData, setOperatorData] = useState({});
  const [userMessage,setUserMessage]=useState("Loading...");


  const Theme = useTheme();

  const history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));
  const menuOpen = Boolean(anchorEl);




  const [value, setValue] =useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [agentData,setAgentData]=useState({});
  const [agentProfile,setAgentProfile]=useState({});

useEffect(()=>{


  var data = {};
  const data1 = localStorage.getItem("nx_ag");
  const data2 = localStorage.getItem("nx_op");
 
  if (data1 != null) {
    data = JSON.parse(data1);
  }

  setAgentData(data);

  get_profile(data['token']);

  get_received(data['token'])
  get_distributed(data['token'])
  get_cashback(data['token'])
  get_cashback_company(data['token'])
  // get_transactions(data['token']);
  // weeklyReport(data['token']);
},[]);

  const [day, setDay] = useState(Format(new Date(), ["yyyy-MM-dd",]));

  const [endDay, setEndDay] = useState(Format(new Date(), ["yyyy-MM-dd",]));



const [balanceMethod,setBalanceMethod]=useState(false);

const [loadProfile,setLoadProfile]=useState(false);
const [balance,setBalance]=useState(0);
const [currency,setCurrency]=useState("");
const [openBalance,setOpenBalance]=useState(0);
const [reservedAmount,setReservedAmount]=useState(0);
const [outlets,setOutlets]=useState([]);
const [statusAccount,setStatusAccount]=useState("");
const [agentType,setAgentType]=useState(null);

const get_profile=(token)=>{
  setLoadProfile(true);
  axios.defaults.baseURL = new FinanceService().BASE_URL;
  const profileInstance = axios.create(new FinanceService().setHeaders(token));
  profileInstance.get(new FinanceService().GET_AGENT_PROFILE+new UserInfo().AGENT_CODE)
  .then(res=>{
    var obj=res.data.data;
    setBalance(obj.account.current_balance);
    setOpenBalance(obj.account.opening_balance);
    setCurrency(obj.account.currency_code);
    setReservedAmount(obj.account.reserved_amount);
    setStatusAccount(obj.account.status);
    setOutlets(obj.outlets);
    setAgentProfile(obj);
    setLoadProfile(false);
    setAgentType(obj.agent_type_name);
    console.log("res",obj);
  })
  .catch(err=>{
    console.log("err",err);
  });
}


const [received,setReceived]=useState(0)
const [distributed,setDistributed]=useState(0)
const [cashBack,setCashBack]=useState(0)
const [cashBackCompany,setCashBackCompany]=useState(0)

  const get_received = (token) => {
    
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const profileInstance = axios.create(new FinanceService().setHeaders(token));
    profileInstance.get(new FinanceService().GET_TOTAL_BY_TRANSACTION_TYPE + '?agent_code=' + new UserInfo().AGENT_CODE + '&self=false&start_date=' + day + '&end_date=' + endDay +'&transaction_type=AFAL')
      .then(res => {
        var datas = res.data.data;
        const total = datas.reduce((Sum, a) => Sum + parseInt(a.total_amount), 0)
        setReceived(total)
        console.log("total",total)
       
      })
      .catch(err => {
        console.log("err", err);
      });
  }

  const get_distributed = (token) => {

    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const profileInstance = axios.create(new FinanceService().setHeaders(token));
    profileInstance.get(new FinanceService().GET_TOTAL_BY_TRANSACTION_TYPE + '?agent_code=' + new UserInfo().AGENT_CODE + '&self=true&start_date=' + day + '&end_date=' + endDay +'&transaction_type=AFAL')
      .then(res => {
        var datas = res.data.data;
        const total = datas.reduce((Sum, a) => Sum + parseInt(a.total_amount), 0)
        setDistributed(total)

      })
      .catch(err => {
        console.log("err", err);
      });
  }

  const get_cashback = (token) => {

    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const profileInstance = axios.create(new FinanceService().setHeaders(token));
    profileInstance.get(new FinanceService().GET_TOTAL_BY_TRANSACTION_TYPE + '?agent_code=' + new UserInfo().AGENT_CODE + '&self=false&start_date=' + day + '&end_date=' + endDay +'&transaction_type=AFCB')
      .then(res => {
        var datas = res.data.data;
        const total = datas.reduce((Sum, a) => Sum + parseInt(a.total_amount), 0)
        setCashBack(total)

      })
      .catch(err => {
        console.log("err", err);
      });
  }

  const get_cashback_company = (token) => {

    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const profileInstance = axios.create(new FinanceService().setHeaders(token));
    profileInstance.get(new FinanceService().GET_TOTAL_BY_TRANSACTION_TYPE + '?agent_code=' + new UserInfo().AGENT_CODE + '&self=true&start_date=' + day + '&end_date=' + endDay +'&transaction_type=AFCB')
      .then(res => {
        var datas = res.data.data;
        const total = datas.reduce((Sum, a) => Sum + parseInt(a.total_amount), 0)
        setCashBackCompany(total)

      })
      .catch(err => {
        console.log("err", err);
      });
  }





//   transactions table 


const columns = [
    {
      name: "tx_type_name",
      label: "Transaction Type",
      options: {
       filter: true,
       sort: true,
      }
     },
    {
     name: "channel_type",
     label: "Channel",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
     name: "credited_account",
     label: "Account",
     options: {
      filter: true,
      sort: false,
     }
    },
    {
      name: "external_reference_number",
      label: "External Reference",
      options: {
       filter: true,
       sort: false,
      }
     },
    {
      name: "amount",
      label: "Amount",
      options: {
       filter: true,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
       return (<Typography>{formatMoney(value,0)}</Typography>);
     }
      }
     }, 
    // {
    //  name: "total_commission_amount",
    //  label: "Commissions",
    //  options: {
    //   filter: true,
    //   sort: false,
    //  }
    // }, 
    {
      name: "debited_account_balance",
      label: "Balance",
      options: {
       filter: true,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
       return (<Typography>{formatMoney(value,0)}</Typography>);
     }
      }
     },{
      name: "tx_date",
      label: "Date",
      options: {
       filter: true,
       sort: true,
      }
     },
     {
      name: "tx_time",
      label: "Time",
      options: {
       filter: true,
       sort: false,
      }
     },
     {
        name: "status",
        label: "Status",
        options: {
         filter: true,
         sort: false,
         customBodyRender: (value, tableMeta, updateValue) => {
          return (<Chip size="small" icon={<CheckCircleOutline color="priamry"/>} label={value} color="primary" variant="outlined" />);
       }
        }
       }
   ];
  
   
   const options = {textLabels: {
    body: {
      noMatch: "No transactions available"
    },
  },
     filterType: 'checkbox',
     download:true,
     responsive:"standard",
     selectableRows:false,
     rowsPerPage: 10,
     elevation:0,
   };
  

   // format money 

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
  }
};

////////////////////////// TOP UP /////////////////////////


// get accounts associated to the phone number 

const [step,setStep]=useState(0);

const [panNumber,setPanNumber]=useState({value:"",error:""});

const [loadAccounts,setLoadAccounts]=useState(false);
const [accounts,setAccounts]=useState([]);
const [phone,setPhone]=useState({value:"",error:""});
const get_accounts=(p)=>{

    if(p.length==12 || p.length==19){
      setAccounts([]);
        setWallet({});
        setLoadAccounts(true);
        let url="";
        if(balanceMethod==false){
          url=new FinanceService().GET_ACCOUNTS+p;
        }else{
          url=new FinanceService().GET_CARD_PROFILE+p;
        }

        axios.defaults.baseURL = new FinanceService().BASE_URL;
        const accountsInstance = axios.create(new FinanceService().setHeaders(agentData.token));
        accountsInstance.get(url)
        .then(res=>{
          // console.log("accounts",objs);
          var objs=[];

          if(balanceMethod==false){
            objs=res.data.data;
          }else{
            objs.push(res.data.data);
          }
          
          setAccounts(objs);
          setLoadAccounts(false);
        })
        .catch(err=>{
          setLoadAccounts(false);
          setAccounts([]);
        });
    
      }else{
        if(balanceMethod==false){
          setPhone({value:"",error:"Enter valid phone number"});
        }else{
          setPanNumber({value:"",error:"Enter valid PAN number"});
        }
      }
  






}


const [wallet,setWallet]=useState({});

const [messageDialog,setMessageDialog]=useState(false);

const [topupLoad,setTopupLoad]=useState(false);
const [amount,setAmount]=useState({value:0,error:""});
const [response,setResponse]=useState({});
const topup=()=>{
  if(amount.value<=0){
    setAmount({value:0,error:""});
  }else{
    setTopupLoad(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const topupInstance = axios.create(new FinanceService().setHeaders(agentData.token));
    topupInstance.post(new FinanceService().TOPUP_CUSTOMER,{
      "channel_type": "WEB",
      "channel_code": "WEB",
      "agent_code": new UserInfo().AGENT_CODE,
      "wallet_id": wallet['wallet_id'],
      "ext_ref_no": getRandom(9),
      "amount": amount.value
    })
    .then(res=>{
      var obj=res.data.data;
      setResponse(obj);

      setMessageDialog(true);
      enqueueSnackbar("Account credited successfuly!", { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    setAccounts([]);
    setStep(0);
    
    setTopupLoad(false);

    // get transactions 

    setDay(Format(new Date(), ["yyyy-MM-dd",]));
    get_transactions(agentData.token,Format(new Date(), ["yyyy-MM-dd",]));

    // get new balance and etc info

    get_profile(agentData.token);
    // update weeklly report
    weeklyReport(agentData.token);

    })
    .catch(err=>{
      setTopupLoad(false);
  if(err.response){
    console.log(err.response.data.message);
  }
    });
  }
}


/// show transactions 
const [totalTransactions,setTotalTransactions]=useState(0);

const [commissions,setCommissions]=useState(0);

const [transactions,setTransactions]=useState([]);
const [transactionLoad,setTransactionLoad]=useState(false);

const [channels,setChannels]=useState([]);
const [channelsValue,setChannelsValue]=useState([]);



const get_transactions=(token)=>{
  setTransactionLoad(true);
  setTransactions([])
  setChannelsValue([]);
  setChannels([]);
  setCommissions(0);
  setTotalTransactions(0);
  axios.defaults.baseURL = new FinanceService().BASE_URL;
  const transactionsInstance = axios.create(new FinanceService().setHeaders(token));
  transactionsInstance.get(new FinanceService().GET_TRANSACTIONS+new UserInfo().AGENT_CODE+"?start_date="+day+"&end_date="+endDay)
  .then(res=>{
    var objs=res.data.data;
    if(objs.length>0){
      var totalTrans=0;
      var com=0;
      var c=[];
      objs.map((o)=>{
        totalTrans=totalTrans+parseInt(o['amount']);
        c.push(o['channel_type']);
        com=com+ parseInt(o['total_commission_amount']);
      });
      setTotalTransactions(totalTrans);
      setCommissions(com);
      var unique_channels=c.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
      var unique_transactions=[];
      unique_channels.map((u)=>{
        var count=0;
        objs.map((o)=>{
          if(o['channel_type']==u){
            count++;
          }
        });
        unique_transactions.push(count);
      });
      setChannels(unique_channels);
      setChannelsValue(unique_transactions);

      setTransactions(objs);
    }
    
    setTransactionLoad(false);
  })
  .catch(err=>{
    setTransactionLoad(false);
  });
};



// generate random number 

function getRandom(length) {

  return Math.floor(Math.pow(10, length-1) + Math.random() * 9 * Math.pow(10, length-1));
  
  }


  const [open,setOpen]=useState("");


  /// get devices 



  // devices table 

const columnsDevice = [
  {
    name: "device_type",
    label: "Device Type",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "serial_number",
   label: "Serial Number",
   options: {
    filter: true,
    sort: true,
   }
  },
   {
      name: "status",
      label: "Status",
      options: {
       filter: true,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
        return (<Chip size="small" icon={<CheckCircleOutline color="priamry"/>} label={value} color="primary" variant="outlined" />);
     }
      }
     }
 ];

 
 const optionsDevice = {textLabels: {
  body: {
    noMatch: "No devices available"
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0,
 };

  const [deviceLoad,setDeviceLoad]=useState(false);
  const [devices,setDevices]=useState([]);
  const get_devices=()=>{
    setDeviceLoad(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const devicesInstance = axios.create(new FinanceService().setHeaders(agentData.token));
    devicesInstance.get(new FinanceService().GET_DEVICES+new UserInfo().AGENT_CODE)
    .then(res=>{
      var objs=res.data.data;
      setDevices(objs);
      setDeviceLoad(false);
    })
    .catch(err=>{
      setDeviceLoad(false);
    });
  }


  /// get outlets 



const columnsOutlet = [
  {
    name: "code",
    label: "Code",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "name",
   label: "Name",
   options: {
    filter: true,
    sort: true,
   }
  },
   {
      name: "status",
      label: "Status",
      options: {
       filter: true,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
         if(value=="DISABLED"){
          return (<Chip size="small" icon={<Block color="secondary"/>} label={value} color="secondary" variant="outlined" />);
         }else{
          return (<Chip size="small" icon={<CheckCircleOutline color="priamry"/>} label={value} color="primary" variant="outlined" />);
         }
        
     }
      }
     }
 ];

 
 const optionsOutlet = {textLabels: {
  body: {
    noMatch: "No outlets available"
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0,
 };



  const [outletLoad,setOutletLoad]=useState(false);
  const get_outlets=()=>{
    setOutletLoad(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const outletsInstance = axios.create(new FinanceService().setHeaders(agentData.token));
    outletsInstance.get(new FinanceService().GET_OUTLETS+new UserInfo().AGENT_CODE)
    .then(res=>{
      var objs=res.data.data;
      setOutlets(objs);
      setOutletLoad(false);
    })
    .catch(err=>{
      setOutletLoad(false);
    });
  }



  // change password 

  const [changeDialog,setChangeDialog]=useState(false);

  const [oldPassword,setOldPassword]=useState({value:"",error:""});
  const [newPassword,setNewPassword]=useState({value:"",error:""});
  const [changeLoad,setChangeLoad]=useState(false);

  const change_password=()=>{
if(oldPassword.value==""){
      setOldPassword({value:"",error:"Enter valid password"});
    }else if(newPassword.value==""){
      setNewPassword({value:"",error:"Enter valid password"});
    }else{
      setChangeLoad(true);
      axios.defaults.baseURL = new AdminService().BASE_URL;
      const changeInstance = axios.create(new AdminService().setHeaders(agentData.token));
      changeInstance.put(new AdminService().CHANGE_PASSWORD,{
        "new_password": newPassword.value,
        "old_password": oldPassword.value
      })
      .then(res=>{
        enqueueSnackbar("Password changed successful!", { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      setChangeDialog(false);
      setChangeLoad(false);
      })
      .catch(err=>{
        setChangeLoad(false);
        if(err.response){
          
          enqueueSnackbar(err.response.data.message, { 
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });

        }
      });
    }
    
  }

  // open topup


  const [openStatus,setOpenStatus]=useState("topup");


  // balance dialog

  const [balanceDialog,setBalanceDialog]=useState(false);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };


  const [logoutOpen, setLogoutOpen] = useState(false);


  // popover for date fetching

  const [weekTx,setWeekTx]=useState([0, 0, 0, 0,0, 0,0]);

  const [anchorEl2, setAnchorEl2] = React.useState(null);

const handleClick2 = (event) => {
  setAnchorEl2(event.currentTarget);
};

const handleClose2 = () => {
  setAnchorEl2(null);
};

const open2 = Boolean(anchorEl2);
const id = open2 ? 'simple-popover' : undefined;


// weekly report 

const weeklyReport=(token)=>{
  var curr = new Date; 
  var first = curr.getDate() - curr.getDay()+1;
  var firstday = new Date(curr.setDate(first));   
  var lastday = new Date(curr.setDate(curr.getDate()+6));


  const startDate=Format(firstday,["yyyy-MM-dd",]);
  const endDate=Format(lastday,["yyyy-MM-dd",]);

  axios.defaults.baseURL = new FinanceService().BASE_URL;
  const transactionsInstance = axios.create(new FinanceService().setHeaders(token));
  transactionsInstance.get(new FinanceService().GET_TRANSACTIONS+new UserInfo().AGENT_CODE+"?start_date="+startDate+"&end_date="+endDate)
  .then(res=>{

    var objs=res.data.data;

    console.log("weekly transactions",objs);

    var groupByDay = groupBy(objs, function(item) {
      return [item.source,item.tx_date];
  });

  console.log("grouped by date");
  console.log(groupByDay);

  var groupedTx=[];

  var weekday = new Array(7);
  weekday[0] = "Sunday";
  weekday[1] = "Monday";
  weekday[2] = "Tuesday";
  weekday[3] = "Wednesday";
  weekday[4] = "Thursday";
  weekday[5] = "Friday";
  weekday[6] = "Saturday";

  // var n = weekday[d.getDay()];


  var days=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  var daysTx=[0,0,0,0,0,0,0];

 
    groupByDay.map((o)=>{

      if(o['']){
  
      }
  
      var txs=o;
  
      var tx_date=txs[0]['tx_date'];
  
      var nDay=new Date(txs[0]['tx_date']);

      // console.log("day");

      // console.log(nDay.getDay());

      var index=nDay.getDay();
  
      var total_amount=txs.reduce(function (sum, amount) {
          return sum + parseInt(amount.amount);
      }, 0);
  
      daysTx[index]=total_amount;

      var obj={"date":tx_date,total_amount:total_amount};
  
      groupedTx.push(obj);
  });

 console.log("daysTx");
 console.log(daysTx);

 var ls=daysTx[0];
 daysTx.shift();
 daysTx.push(ls);

 console.log("after shift");
 console.log(daysTx);
 

 setWeekTx(daysTx);


console.log("grouped transction");
console.log(groupedTx);


    // group by week days 



  })
  .catch(err=>{
    

  });


}


const weeklyTopup={
          
  series: [{
    data: weekTx 
  }],
  options: {
    chart: {
      type: 'bar',
      height: 380
    },
    plotOptions: {
      bar: {
        barHeight: '100%',
        distributed: true,
        horizontal: true,
        dataLabels: {
          position: 'bottom'
        },
      }
    },
    colors: [ '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
      '#f48024', '#69d2e7'
    ],
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: {
        colors: ['#120E1D']
      },
      formatter: function (val, opt) {
        return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
      },
      offsetX: 0,
      dropShadow: {
        enabled: false
      }
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    },
    yaxis: {
      labels: {
        show: false
      }
    },
    title: {
        text: 'Weekly transactions',
        align: 'center',
        floating: true
    },
    tooltip: {
      theme: 'dark',
      x: {
        show: false
      },
      y: {
        title: {
          formatter: function () {
            return ''
          }
        }
      }
    }
  },
};



  return (
    <div className={classes.root}>

    <Box>                  
    <Grid container spacing={2}>
    <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box display="flex"><Home fontSize="large" color="primary"/><Typography style={{flexGrow:1}} variant="h6">Home</Typography><Event color="primary" fontSize="large"/> <Typography variant="h6">{Format(new Date(),["yyyy-MM-dd",])}</Typography></Box>
        </Grid>
        {/* <Grid item xs={12} sm={6} md={4} lg={3}>
          <Paper elevation={0} className={classes.paper}>
            <Box width={1} display="flex" justifyContent="center">
              <Box flexGrow={1}>
                <Typography color="textSecondary">Total Transactions</Typography>
                <Box mt={1} mb="4px" flexGrow={1}>
                  <Typography variant="h6">{formatMoney(totalTransactions,0)+" RWF"}</Typography>
                </Box>
               
              </Box>
              <SwapHoriz color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid> */}
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" width={1}>
              <Box flexGrow={1}>
                <Typography color="textSecondary">Current Float Balance</Typography>
                <Box mt={1} mb="4px">
                <Typography variant="h6">{ formatMoney(balance,0)+" "+currency}</Typography>
                </Box>
                {/* <Chip
                className={classes.btn}
                  color="primary"
                  size="small"
                  label={statusAccount=="ENABLED"?"Active":"Inactive"}
                  deleteIcon={<Done />}
                  onDelete={()=>{

                  }}
                /> */}
              </Box>
              <AccountBalanceWallet color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" width={1}>
              <Box flexGrow={1}>
                <Typography color="textSecondary">
                 Opening Balance
                </Typography>
                <Box mt={1} mb="4px">
                <Typography variant="h6">{ formatMoney(openBalance,0)+" "+currency}</Typography>
                </Box>
                {/* <Chip
                className={classes.btn}
                  color="primary"
                  size="small"
                  label={statusAccount=="ENABLED"?"Active":"Inactive"}
                  deleteIcon={<Done/>}
                  onDelete={()=>{

                  }}
                /> */}
              </Box>
              <AccountBalance color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid>
        {/* <Grid item xs={12} sm={6} md={4} lg={4}>
          <Paper elevation={0} className={classes.paper}>
            <Box display="flex" width={1}>
              <Box flexGrow={1}>
                <Typography color="textSecondary">Commissions</Typography>
                <Box mt={1} mb="4px">
                <Typography variant="h6">{commissions+" RWF"}</Typography>
                </Box>
               
              </Box>
              <Money color="primary" fontSize="large" />
            </Box>
          </Paper>
        </Grid> */}


          <Grid item xs={12} sm={6} md={4} lg={4}>
            <Paper elevation={0} className={classes.paper}>
              <Box display="flex" width={1}>
                <Box flexGrow={1}>
                  <Typography color="textSecondary">Received</Typography>
                  <Box mt={1} mb="4px">
                    <Typography variant="h6">{formatMoney(received, 0) + " " + currency}</Typography>
                  </Box>
                  {/* <Chip
                className={classes.btn}
                  color="primary"
                  size="small"
                  label={statusAccount=="ENABLED"?"Active":"Inactive"}
                  deleteIcon={<Done />}
                  onDelete={()=>{

                  }}
                /> */}
                </Box>
                <AccountBalanceWallet color="primary" fontSize="large" />
              </Box>
            </Paper>
          </Grid>


          <Grid item xs={12} sm={6} md={4} lg={4}>
            <Paper elevation={0} className={classes.paper}>
              <Box display="flex" width={1}>
                <Box flexGrow={1}>
                  <Typography color="textSecondary">Distributed</Typography>
                  <Box mt={1} mb="4px">
                    <Typography variant="h6">{formatMoney(distributed, 0) + " " + currency}</Typography>
                  </Box>
                  {/* <Chip
                className={classes.btn}
                  color="primary"
                  size="small"
                  label={statusAccount=="ENABLED"?"Active":"Inactive"}
                  deleteIcon={<Done />}
                  onDelete={()=>{

                  }}
                /> */}
                </Box>
                <AccountBalanceWallet color="primary" fontSize="large" />
              </Box>
            </Paper>
          </Grid>


          <Grid item xs={12} sm={6} md={4} lg={4}>
            <Paper elevation={0} className={classes.paper}>
              <Box display="flex" width={1}>
                <Box flexGrow={1}>
                  <Typography color="textSecondary">Cash Back</Typography>
                  <Box mt={1} mb="4px">
                    <Typography variant="h6">{formatMoney(cashBack, 0) + " " + currency}</Typography>
                  </Box>
                  {/* <Chip
                className={classes.btn}
                  color="primary"
                  size="small"
                  label={statusAccount=="ENABLED"?"Active":"Inactive"}
                  deleteIcon={<Done />}
                  onDelete={()=>{

                  }}
                /> */}
                </Box>
                <AccountBalanceWallet color="primary" fontSize="large" />
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={4}>
            <Paper elevation={0} className={classes.paper}>
              <Box display="flex" width={1}>
                <Box flexGrow={1}>
                  <Typography color="textSecondary">Cash Back To Company</Typography>
                  <Box mt={1} mb="4px">
                    <Typography variant="h6">{formatMoney(cashBackCompany, 0) + " " + currency}</Typography>
                  </Box>
                  {/* <Chip
                className={classes.btn}
                  color="primary"
                  size="small"
                  label={statusAccount=="ENABLED"?"Active":"Inactive"}
                  deleteIcon={<Done />}
                  onDelete={()=>{

                  }}
                /> */}
                </Box>
                <AccountBalanceWallet color="primary" fontSize="large" />
              </Box>
            </Paper>
          </Grid>

        {/* <Grid item xs={12} md={12} lg={12} sm={12}>
            <Box display="flex">
                <Typography variant="h6" style={{flexGrow:1}}>Transactions</Typography>
            </Box>
        </Grid> */}

        {/* <Grid item xs={12} md={6} lg={6} sm={6}>
            <Paper elevation={0}>
     <Chart   options={weeklyTopup.options} series={weeklyTopup.series} type="bar" height={380} />
     </Paper>
     </Grid> */}
     {/* <Grid item xs={12} md={6} lg={6} sm={6}>
         <Paper elevation={0}>
         <Chart   options={AnnualTopUp.options} series={AnnualTopUp.series} type="bar" height={380} />
         </Paper>
     </Grid> */}

       </Grid>
        
        </Box>

       


    </div>
  );
}

export default  withLocalize(AgentHome);